import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { useAppDispatch } from '../../../helpers/hooks';
import { useWorkspaceSlice } from '../slice';

interface CreateKeyDialogProps {
  open: boolean;
  projectId: string;
  onClose: () => void;
}

export default function CreateKeyDialog({
  open,
  projectId,
  onClose,
}: CreateKeyDialogProps) {
  const dispatch = useAppDispatch();
  const { actions } = useWorkspaceSlice();

  const [key, setKey] = useState('');
  const [sourceText, setSourceText] = useState('');
  const [context, setContext] = useState('');

  const handleSubmit = () => {
    dispatch(
      actions.createKeyRequest({
        projectId,
        key,
        sourceText,
        context: context || undefined,
      }),
    );
    setKey('');
    setSourceText('');
    setContext('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add translation key</DialogTitle>
      <DialogContent>
        <Stack spacing={2.5} sx={{ mt: 1 }}>
          <TextField
            label="Key"
            placeholder="home.hero.title"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label="Source text"
            value={sourceText}
            onChange={(e) => setSourceText(e.target.value)}
            fullWidth
            required
            multiline
            minRows={2}
          />
          <TextField
            label="Context (optional)"
            placeholder="Tone, screen, character limits…"
            value={context}
            onChange={(e) => setContext(e.target.value)}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!key || !sourceText}
        >
          Add key
        </Button>
      </DialogActions>
    </Dialog>
  );
}
